export class MerchPercentageFilter {
  public IncludeInactive?: boolean;
}

export default MerchPercentageFilter;